import { Trans } from "@lingui/macro";
import Blocks from "editorjs-blocks-react-renderer";
import React, { MouseEvent } from "react";

import Truncate from "./Truncate";

export interface ShowMoreProps {
	jsonStringData?: string;
	expandable?: boolean;
	lines?: number;
	onExpandPress?: () => void;
	expanded?: boolean;
}

class ShowMore extends React.Component<ShowMoreProps, { expanded: boolean }> {
	private articleRef: React.RefObject<HTMLParagraphElement>;

	constructor(props: ShowMoreProps) {
		super(props);
		this.onExpandClick = this.onExpandClick.bind(this);
		this.setExpanded = this.setExpanded.bind(this);
		this.scrollIntoView = this.scrollIntoView.bind(this);
		this.state = { expanded: props.expanded || false };

		this.articleRef = React.createRef();
	}

	setExpanded() {
		const { expandable } = this.props;
		if (!expandable) {
			return;
		}
		this.setState({ expanded: true });
	}

	scrollIntoView() {
		this.articleRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
	}

	onExpandClick(event: MouseEvent<HTMLButtonElement>) {
		event.preventDefault();
		this.setExpanded();
		const { onExpandPress } = this.props;
		onExpandPress && onExpandPress();
	}

	render() {
		const { jsonStringData, lines = 3, expanded: expandedProps } = this.props;
		const { expanded } = this.state;

		if (!jsonStringData) {
			return null;
		}
		let data;
		try {
			data = JSON.parse(jsonStringData);
		} catch (e) {
			console.error("Rich text data are not valid JSONString.");
			return null;
		}
		if (!data.time || !data.version || !data.blocks.length) {
			console.error("Rich text data not in the EditorJS format.");
			return null;
		}

		if (expanded || expandedProps) {
			return (
				<div ref={this.articleRef} className="text-sm prose lg:prose-s max-w-full">
					<Blocks data={data} />
				</div>
			);
		}

		return (
			<Truncate
				lines={expanded ? 0 : lines}
				ellipsis={
					<span>
						...
						<button onClick={this.onExpandClick} className="px-1 text-brand-blue">
							<Trans>View more details</Trans>
						</button>
					</span>
				}
				className="text-sm"
			>
				<div ref={this.articleRef} className="text-sm prose lg:prose-s max-w-full">
					<Blocks data={data} />
				</div>
			</Truncate>
		);
	}
}

export default ShowMore;
